import Vue from 'vue'

Vue.mixin({
  methods: {
    reset(uncheck = true) {
      this.materialResponse = null
      this.form.data = this.defaultData()
      this.form.options.errors = {}

      if (uncheck) {
        let gridHash = $('#form_hash').val()

        if (`${gridHash}_markVisible` in window) {
          window[`${gridHash}_markVisible`](false)
        }
      }

    },
    updateMealName(event, shiftIndex) {
      this.form.data.shifts[shiftIndex].mealName = event.$event.name
      this.form.data.shifts[shiftIndex].mealSelectName = event.$event.nameForSelect
    },
    updateObject(event, shiftIndex) {
      this.form.data.shifts[shiftIndex].item.unit = event.$event.unit
      this.form.data.shifts[shiftIndex].item.unitWeight = event.$event.unitWeight
    },
    translateUnit(name) {
      return name ? Translator.trans(`warehouse_shift.entity.units.${name}`) : '-'
    },
    trans(name) {
      return Translator.trans(name)
    },
    translateObjectType(name) {
      return name ? Translator.trans(`warehouse_shift.entity.object_types.${name}`) : '-'
    },
    translateObject(object) {
      return object ? object.name : '-'
    },
    translateUserListObj(obj) {
      return obj.username
    },
    translateListObj(obj) {
      return obj.name
    },

  }
})
